var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "input",
    _vm._b(
      {
        staticClass: "Nomerpick__inp",
        class: { invalid: !_setup.isValid },
        attrs: {
          type: "text",
          inputmode: "numeric",
          autocomplete: "off",
          placeholder: _setup.props.placeholder,
          maxlength: "8",
        },
        domProps: { value: _setup.localValue },
        on: { input: _setup.onInput },
      },
      "input",
      _vm.$attrs,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }